import ActionTypes from "../Actions/ActionTypes";

let initialState = {
  guestUpcomingEvents: [],
  EventDetails: null,
  guestRsvpDetails: null,
};

const GuestReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GUEST_UPCOMING_EVENTS:
      state = { ...state, guestUpcomingEvents: action.payload };
      break;
    case ActionTypes.GUEST_EVENTS_WEDWALL:
      state = {
        ...state,
        EventDetails: { ...state.EventDetails, well_wish: action.payload },
      };
      break;

      case ActionTypes.GUEST_EVENTS_DETAIL:
        state = {
          ...state,
          EventDetails: action.payload,
        };
        break;

    case ActionTypes.GET_GUEST_RSVP_DETAILS:
      state = { ...state, guestRsvpDetails: action.payload };
      break;

    case ActionTypes.UPDATE_GUEST_RSVP_EVENT:
      let Update_Event_List_Copy = [...state.guestUpcomingEvents];
      let index = Update_Event_List_Copy.findIndex(
        (item) => item?.id == action?.payload?.id
      );
      action?.payload?.is_accepted_invitation
        ? Update_Event_List_Copy.splice(index, 1, action?.payload)
        : Update_Event_List_Copy.splice(index, 1);
      state = {
        ...state,
        guestUpcomingEvents: Update_Event_List_Copy,
      };
      break;

    default:
      break;
  }
  return state;
};

export default GuestReducer;
